// Scripting for sliders or carousels (Baytek gutenblocks plugin includes a slider block that uses slick slider)
(function($){

	// Simple Slider Block using Slick.js
	$('.carousel-slider').slick({
		arrows: true,
		dots: true,
		slidesToScroll: 1,
		slidesToShow: 4,
		infinite: true,
		// variableWidth: true,
		draggable: true,
		prevArrow: '<button type="button" class="slick-prev slick-arrow"><i class="fal fa-chevron-left"></i></button>',
		nextArrow: '<button type="button" class="slick-next slick-arrow"><i class="fal fa-chevron-right"></i></button>',
		responsive: [{
			breakpoint: 1600,
			settings: {
				slidesToShow: 3
			}
		},{
			breakpoint: 1000,
			settings: {
				slidesToShow: 2
			}
		},{
			breakpoint: 500,
			settings: {
				slidesToShow: 1
			}
		}]
	});



	// Gallery Sliders
	$('.gallery-slider').slick({
		arrows: true,
		dots: false,
		slidesToScroll: 2,
		slidesToShow: 4,
		infinite: true,
		variableWidth: false,
	    autoplay: false,
	    autoplaySpeed: 3000,
		prevArrow: '<div class="slick-arrow wp-block-buttons arrow left-arrow"><div class="wp-block-button"><span class="wp-block-button__link"></span></div></div>',
		nextArrow: '<div class="slick-arrow wp-block-buttons arrow right-arrow"><div class="wp-block-button"><span class="wp-block-button__link"></span></div></div>',
		responsive: [{
			breakpoint: 2400,
			settings: {
				slidesToShow: 5,
			}
		},{
			breakpoint: 1600,
			settings: {
				slidesToShow: 4,
			}
		},{
			breakpoint: 1200,
			settings: {
				slidesToShow: 3
			}
		},{
			breakpoint: 900,
			settings: {
				slidesToShow: 2
			}
		},{
			breakpoint: 600,
			settings: {
				slidesToScroll: 1,
				slidesToShow: 1
			}
		}]
	});


})(jQuery);